import {
    SearchCategory,
    SearchResultItem,
    SearchResultItemType,
    SearchResults,
    CustomerRow,
    DeviceRow,
    FarmRow,
    PartRow,
    TechnicianRow,
} from "@/components/layout/Navbar/ApplicationSearch/application-search.types";

const typeSortPriority: Record<SearchResultItemType, number> = {
    customer: 0,
    customerExtended: 0,
    device: 0,
    farm: 0,
    technician: 0,
    part: 1, // Partial part search can return many results, so sort them last to prioritize specific matches.
};

export const getSortValueCustomer = (item: CustomerRow) => item.Name;
export const getSortValueDevice = (item: DeviceRow) => item.DeviceSerialNumber;
export const getSortValueFarm = (item: FarmRow) => item.FarmLicenseKey;
export const getSortValueTechnician = (item: TechnicianRow) => item.Name ?? "";
export const getSortValuePart = (item: PartRow) => item.PartNumber;

export const toSearchResultItem = (category: SearchCategory, data: SearchResults) => {
    let items: SearchResultItem[];

    if (category === "customer") {
        items = data.customers.map((customer) => ({
            sortValue: getSortValueCustomer(customer),
            type: "customer",
            data: customer,
        }));
    } else if (category === "device") {
        items = data.devices.map((device) => ({
            sortValue: getSortValueDevice(device),
            type: "device",
            data: device,
        }));
    } else if (category === "farm") {
        items = data.farms.map((farm) => ({
            sortValue: getSortValueFarm(farm),
            type: "farm",
            data: farm,
        }));
    } else if (category === "technician") {
        items = data.technicians.map((technician) => ({
            sortValue: getSortValueTechnician(technician),
            type: "technician",
            data: technician,
        }));
    } else if (category === "part") {
        items = data.parts.map((part) => ({
            sortValue: getSortValuePart(part),
            type: "part",
            data: part,
        }));
    } else {
        items = [
            ...data.customers.map((customer) => ({
                sortValue: getSortValueCustomer(customer),
                type: "customerExtended" as const,
                data: customer,
            })),
            ...data.technicians.map((technician) => ({
                sortValue: getSortValueTechnician(technician),
                type: "technician" as const,
                data: technician,
            })),
            ...data.parts.map((part) => ({
                sortValue: getSortValuePart(part),
                type: "part" as const,
                data: part,
            })),
        ];
    }
    return items;
};

export const sortSearchResultItems = (items: SearchResultItem[]) =>
    [...items].sort((a, b) => {
        const priorityDiff = typeSortPriority[a.type] - typeSortPriority[b.type];
        return priorityDiff !== 0 ? priorityDiff : a.sortValue?.localeCompare(b.sortValue);
    });
